import React, { useEffect, useCallback, useState } from 'react';

import { HeaderCharts } from '../HeaderCharts';
import { DashboardChart } from 'components/ChartDashboard';
import { getChartThirdPartyEvaluation } from 'services/chartPizza';
import { useBoolean } from 'hooks/useBoolean';
import { Loading } from 'components';
import { Flex } from '@chakra-ui/react';

import * as Styles from '../../style';

export const Chart_ThirdPartyEvaluation: React.FC = () => {
  const [isLoading, toggleIsLoading] = useBoolean(false);

  const [valueFinished, setValueFinished] = useState<number>(0);
  const [inProgress, setInProgress] = useState<number>(0);
  const [noData, setNoData] = useState<boolean>();
  const [isPermition, setIsPermition] = useState<boolean>(false);
  const handleDataChart = useCallback(async () => {
    try {
      toggleIsLoading(true);
      const resume = await getChartThirdPartyEvaluation();
      const data = Array.from(resume.data.series[0].data);

      if (data.length === 0) {
        toggleIsLoading(false);
        setNoData(true);
        return;
      }
      const arrayStatus = data.filter(item =>
        item.name !== 'Avaliação Jurídica' ? { ...item } : '',
      );

      const [statusCountFinished] = arrayStatus.filter(
        item => item.name === 'Finalizado' ?? undefined,
      );

      const [statusCountInProgress] = arrayStatus.filter(
        item => item.name === 'Em andamento' ?? undefined,
      );
      setValueFinished(statusCountFinished?.countTotal ?? 0);
      setInProgress(statusCountInProgress?.countTotal ?? 0);
      toggleIsLoading(false);
    } catch (err) {
      console.log(err);
      setIsPermition(true);
    }
  }, [noData]);

  useEffect(() => {
    handleDataChart();
  }, []);

  const renderConditional = () => {
    if (noData) {
      return (
        <Flex width={'100%'} align="center" justify={'center'}>
          <p>Não há dados a retornar!</p>
        </Flex>
      );
    } else {
      return <DashboardChart finishedValue={valueFinished} inProgressValue={inProgress} />;
    }
  };

  return (
    <Styles.ContainerCharts>
      <HeaderCharts head="Avaliação de terceiros" />
      <Styles.ContentCharts>
        {isLoading ? (
          <Flex width={'100%'} align="center" justify={'center'}>
            {isPermition ? <span>Você não possui acesso a este formulário. </span> : <Loading />}
          </Flex>
        ) : (
          renderConditional()
        )}
      </Styles.ContentCharts>
    </Styles.ContainerCharts>
  );
};
